<h2
  class="lg:mt-10 xs:mt-1 py-4 text-center text-3xl leading-9 font-extrabold text-[#7B68EE]"
>
  All Coupons
</h2>

<!-- No Reviews Template -->

  <div
    class="flex flex-col items-center justify-center text-center py-10"
  >
    <svg
      class="w-20 h-20 text-purple-700"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9 14c0 0 1.5 2 3 2s3-2 3-2m6-2a9 9 0 11-18 0 9 9 0 0118 0zm-6-3h.01M9 11h.01"
      />
    </svg>
    <h1 class="text-purple-700 font-medium text-lg mt-4">
      No Coupons Found
    </h1>
    <p class="text-gray-600 mt-2">
      You have not any Coupons yet!
    </p>
  </div>
